module.exports = __webpack_public_path__ + "static/media/summerCut-01.d6043d69.png";